import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

export const petAppointment = createAsyncThunk(
  "petAppointment",
  async (data, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/book/appointment/pet/${data?.petId}`,
        data?.data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment created successfully!",
            type: "success",
          }),
        );
        return res.data;
      }
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const petAppointmentImmediate = createAsyncThunk(
  "petAppointmentImmediate",
  async (data, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/book/immediate/appointment/pet/${data?.petId}`,
        data?.data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment created successfully!",
            type: "success",
          }),
        );
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getPetDetailsById = createAsyncThunk(
  "getPetDetailsById",
  async (petId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/details`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetDetailsByIdWoLoader = createAsyncThunk(
  "getPetDetailsByIdWoLoader",
  async (petId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/details`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetDetailForSoapByIdWoLoader = createAsyncThunk(
  "getPetDetailForSoapByIdWoLoader",
  async (petId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/user/pet/${petId}/details`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getSlotByDoctorId = createAsyncThunk(
  "getSlotByDoctorId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/user/${data?.getId}/slots?type=${data?.type}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getSlotTime = createAsyncThunk(
  "getSlotTime",
  async (data, thunkAPI) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `clinic/${user?.id}/doctor/${data?.doctorId}/day?type=${data?.contType}&date=${data?.date}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetsCompliantSummary = createAsyncThunk(
  "getPetsCompliantSummary",
  async (appointmentId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointments/${appointmentId}/pet/compliantSummary`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetsCompliantSummaryWoLoader = createAsyncThunk(
  "getPetsCompliantSummaryWoLoader",
  async (appointmentId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointments/${appointmentId}/pet/compliantSummary`,
      );

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getCompliantSummaryByIdWoLoader = createAsyncThunk(
  "getCompliantSummaryByIdWoLoader",
  async (appointmentId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointments/${appointmentId}/pet/compliantSummary`,
      );

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateNoteByAppointmentIdWoLoader = createAsyncThunk(
  "updateNoteByAppointmentIdWoLoader",
  async ({ id, note, remarks, facilityId, facility }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const encodedNote = note ? encodeURIComponent(note) : "";
      const encodedRemarks = remarks ? encodeURIComponent(remarks) : "";
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/${id}/note?note=${encodedNote}&remarks=${encodedRemarks}&facilityId=${
          facilityId || ""
        }&facility=${facility || ""}`,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const addCoOwnerByPetId = createAsyncThunk(
  "addCoOwnerByPetId",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${petId}/coowner`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Co-Owner added successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const addInternalNoteByPetId = createAsyncThunk(
  "addInternalNoteByPetId",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${petId}/internalNote`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Internal Note added successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateInternalNoteByPetAndNoteId = createAsyncThunk(
  "updateInternalNoteByPetAndNoteId",
  async ({ petId, noteId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/pet/${petId}/internalNote/${noteId}`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Internal Note updated successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateAllergiesByPetId = createAsyncThunk(
  "updateAllergiesByPetId",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${petId}/allergies`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Allergies added successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateInternalTagsByPetId = createAsyncThunk(
  "updateInternalTagsByPetId",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${petId}/internalTags`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Internal Tags added successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const addAllergyByPetId = createAsyncThunk(
  "addAllergyByPetId",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${petId}/allergies`,
        data,
      );

      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Allergy added successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createPreventive = createAsyncThunk(
  "createPreventive",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`appointment/${data?.appointmentId}/preventive/web`, data?.form);

      if (res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createPreventiveByPetId = createAsyncThunk(
  "createPreventiveByPetId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/pet/${data?.petId}/preventive`, data?.form);
      if (res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createPreventiveByPetIdWoLoader = createAsyncThunk(
  "createPreventiveByPetIdWoLoader",
  async ({ petId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/pet/${petId}/preventive`, form);
      if (res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createPreventiveFromProcedure = createAsyncThunk(
  "createPreventiveFromProcedure",
  async ({ appointmentId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/appointment/${appointmentId}/preventive`, form);
      if (res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createPreventiveFromProcedureWoLoader = createAsyncThunk(
  "createPreventiveFromProcedureWoLoader",
  async ({ appointmentId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/appointment/${appointmentId}/preventive/web`, form);
      if (res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updatePreventive = createAsyncThunk(
  "updatePreventive",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`appointment/preventive/${data?.preventId}/web`, data?.form);

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const deletePreventive = createAsyncThunk(
  "deletePreventive",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/preventive/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Preventive removed successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createPrescription = createAsyncThunk(
  "createPrescription",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `appointment/${data?.appointmentId}/prescription`,
        data?.data,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createPrescriptionWoLoader = createAsyncThunk(
  "createPrescriptionWoLoader",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `appointment/${data?.appointmentId}/prescription`,
        data?.data,
      );

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createPrescriptionByPetId = createAsyncThunk(
  "createPrescriptionByPetId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pet/${data?.petId}/prescription`,
        data?.data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePrescriptionById = createAsyncThunk(
  "updatePrescriptionById",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/prescription/${data?.prescriptionId}`,
        data?.data,
      );

      if (res.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription updated successfully!",
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePrescriptionByIdWoLoader = createAsyncThunk(
  "updatePrescriptionByIdWoLoader",
  async ({ prescriptionId, data }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/prescription/${prescriptionId}`,
        data,
      );

      if (res.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription updated successfully!",
            type: "success",
          }),
        );
        return res?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatedDiscontinueByPresDetId = createAsyncThunk(
  "updatedDiscontinueByPresDetId",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/prescription/prescriptionDetails/${id}?discontinued=Y`,
      );
      if (res.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription Status updated successfully!",
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deletePrescriptionItemByIdWoLoader = createAsyncThunk(
  "deletePrescriptionItemByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/appointment/prescription/prescriptionDetails/${id}`,
      );
      if (res.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription Item deleted successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deletePrescriptionByIdWoLoader = createAsyncThunk(
  "deletePrescriptionByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/appointment/prescription/${id}`,
      );
      if (res.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription deleted successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePrescription = createAsyncThunk(
  "updatePrescription",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `appointment/prescription/${data?.prescriptionId}`,
        data?.data,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createDiagnostics = createAsyncThunk(
  "createDiagnostics",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: data?.formData ?? false,
      }).post(
        `appointment/${data?.appointmentId}/diagonistics/web`,
        data?.form ?? data?.data,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createDiagnosticsWoLoader = createAsyncThunk(
  "createDiagnosticsWoLoader",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: data?.formData ?? false,
      }).post(
        `appointment/${data?.appointmentId}/diagonistics/web`,
        data?.form ?? data?.data,
      );

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createDiagnosticsByPetId = createAsyncThunk(
  "createDiagnosticsByPetId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: data?.formData ?? false,
      }).post(
        `/pet/${data?.petId}/diagonistics`,
        data?.formData ? data?.form : data?.data,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record created successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateDiagnostics = createAsyncThunk(
  "updateDiagnostics",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`appointment/diagonistics/${data?.diagnosticsId}/web`, data?.form);

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateDiagnosticsWoLoader = createAsyncThunk(
  "updateDiagnosticsWoLoader",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`appointment/diagonistics/${data?.diagnosticsId}/web`, data?.form);

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const addUpdateTemplateByDiagnosticId = createAsyncThunk(
  "addUpdateTemplateByDiagnosticId",
  async ({ diagId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/diagnostic/${diagId}/template`,
        data,
      );
      if (res.status === 200 || res.status == 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Changes updated failed",
          type: "error",
        }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Changes updated failed",
          type: "error",
        }),
      );
    }
  },
);

export const deleteDiagnosticsById = createAsyncThunk(
  "deleteDiagnosticsById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/diagonistics/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Diagnostics deleted successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteDiagnosticsByIdWoLoader = createAsyncThunk(
  "deleteDiagnosticsByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/diagonistics/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Diagnostics deleted successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateWeightByPetAndApntId = createAsyncThunk(
  "updateWeightByPetAndApntId",
  async ({ url }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/appointment${url}`,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet weight updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Pet weight update failed", type: "error" }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Pet weight update failed", type: "error" }),
      );
      return false;
    }
  },
);

export const updatePetById = createAsyncThunk(
  "updatePetById",
  async ({ petId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/user/update/pet/${petId}`, form);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return false;
    }
  },
);

export const getPets = createAsyncThunk(
  "getPets",
  async (url = null, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `getall/pets${url ? `${url}` : ""}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetByUserId = createAsyncThunk(
  "getPetByUserId",
  async (userId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/user/${userId}/pets/list`,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getMedicalHistoryByPetId = createAsyncThunk(
  "getMedicalHistoryByPetId",
  async ({ url = "?type=all", petId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/medicalHistory/search/${petId}${url ? `${url}` : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getMedicalHistoryById = createAsyncThunk(
  "getMedicalHistoryById",
  async (medHisId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/medicalHistory/detail/${medHisId}?pet=true&web=true&petowner=true`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createPet = createAsyncThunk(
  "createPet",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post("/clinic/user/pet", data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet created successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createUserPetByUserId = createAsyncThunk(
  "createUserPetByUserId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/user/${data?.userId}/pet`, data?.data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet created successfully",
            type: "success",
          }),
        );
        return res?.data?.data;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createPetNewRegister = createAsyncThunk(
  "createPetNewRegister",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post("pets", data);
      if (res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet created successfully",
            type: "success",
          }),
        );
        return res?.data;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePet = createAsyncThunk(
  "updatePet",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).patch(`pets/${data?.petId}`, data?.form);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet updated successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getPetPreventives = createAsyncThunk(
  "getPetPreventives",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/preventive${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getFilterdPetPreventives = createAsyncThunk(
  "getFilterdPetPreventives",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/preventive${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetPrescriptions = createAsyncThunk(
  "getPetPrescriptions",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/prescription${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetPrescriptionsWoLoader = createAsyncThunk(
  "getPetPrescriptionsWoLoader",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/prescription${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetDiagnostics = createAsyncThunk(
  "getPetDiagnostics",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/diagonistics${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetDiagnosticsWoLoader = createAsyncThunk(
  "getPetDiagnosticsWoLoader",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/diagonistics${url}`,
      );

      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetTypes = createAsyncThunk(
  "getPetTypes",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/species${url}`,
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetColorsByType = createAsyncThunk(
  "getPetColorsByType",
  async (type, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/color",
        // `/color?type=${type}`
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetBreedsByType = createAsyncThunk(
  "getPetBreedsByType",
  async (type, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/species/${type}/breeds`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicPets = createAsyncThunk(
  "getClinicPets",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/pets${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicPetList = createAsyncThunk(
  "getClinicPetList",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pets-list`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicPetsForSuggestion = createAsyncThunk(
  "getClinicPetsForSuggestion",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pets-list`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createPetPrescription = createAsyncThunk(
  "createPetPrescription",
  async ({ petId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/pets/prescription/upload/${petId}`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Prescription created successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const admitPatientByPatientId = createAsyncThunk(
  "admitPatientByPatientId",
  async ({ patientId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/add/inpatient/${patientId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Patient Admitted successfully",
            type: "success",
          }),
        );
        return res?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const admitPet = createAsyncThunk(
  "admitPet",
  async ({ petId, vetId, data, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/add/inpatient/pet/${petId}/doctor/${vetId}${url}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Patient Admitted successfully",
            type: "success",
          }),
        );
        return res?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePetStatusById = createAsyncThunk(
  "updatePetStatusById",
  async ({ petId, status = false }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/pet/${petId}/update?status=${status}`,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet status updated successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getProceduresByPetId = createAsyncThunk(
  "getProceduresByPetId",
  async ({ petId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/pet/${petId}/procedure${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createProcedure = createAsyncThunk(
  "createProcedure",
  async (
    { data, successMessage = "Procedure added successfully" },
    thunkAPI,
  ) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/procedure`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: successMessage,
            type: "success",
          }),
        );
        return res?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createProcedureWoLoader = createAsyncThunk(
  "createProcedureWoLoader",
  async (
    { data, successMessage = "Procedure added successfully" },
    thunkAPI,
  ) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/procedure`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: successMessage,
            type: "success",
          }),
        );
        return res?.data;
      } else {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deleteProcedureDetailByIdWoLoader = createAsyncThunk(
  "deleteProcedureDetailByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/procedure/detail/${id}`,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Item removed successfully",
            type: "success",
          }),
        );
        return true;
      } else {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateProcedureById = createAsyncThunk(
  "updateProcedureById",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/procedure/${id}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Procedure updated successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateProcedureByIdWoLoader = createAsyncThunk(
  "updateProcedureByIdWoLoader",
  async ({ id, data }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/procedure/${id}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Procedure updated successfully!",
            type: "success",
          }),
        );
        // thunkAPI.dispatch(hideLoader());
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateProcedureDateAndRemarkById = createAsyncThunk(
  "updateProcedureDateAndRemarkById",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/procedure/${id}/date`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Procedure updated successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const addProcedureToBilling = createAsyncThunk(
  "addProcedureToBilling",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/${id}/procedure/payment`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const addProcedureToBillingWoLoader = createAsyncThunk(
  "addProcedureToBillingWoLoader",
  async ({ id, data }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/${id}/procedure/payment`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const addMultipleProcedureToBillingWoLoader = createAsyncThunk(
  "addMultipleProcedureToBillingWoLoader",
  async ({ id, list }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `appointment/${id}/multiple/procedure/payment`,
        list,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const deleteProcedureById = createAsyncThunk(
  "deleteProcedureById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/procedure/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Procedure removed successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteProcedureByIdWoLoader = createAsyncThunk(
  "deleteProcedureByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/procedure/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Procedure removed successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const petSlice = createSlice({
  name: "pet",
  initialState: {
    pets: { totalRecords: 0, pets: [] },
    clinicPets: { totalRecords: 0, pets: [] },
    clinicPetList: { totalRecords: 0, pets: [] },
    clinicPetsSuggestion: { totalRecords: 0, pets: [] },
    medicalHistorys: { totalRecords: 0, medicalHistorys: [] },
    medicalHistory: {},
    complaintSummary: null,
    lastSummary: null,
    slotList: null,
    preventives: [],
    prescriptions: [],
    diagnostics: [],
    types: [],
    colors: [],
    petDetails: null,
    filteredPreventives: [],
    procedure: {},
    petDetailsForSoap: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPets.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.pets = { pets: payLoad?.data, totalRecords: payLoad?.data?.length };
    });
    //clinic Details
    builder.addCase(getClinicPets.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.clinicPets = {
        pets: payLoad?.data,
        totalRecords: payLoad?.totalRecords,
      };
    });
    builder.addCase(getClinicPetList.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.clinicPetList = {
        pets: payLoad?.data,
        totalRecords: payLoad?.totalRecords,
      };
    });
    builder.addCase(getClinicPetsForSuggestion.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.clinicPetsSuggestion = {
        pets: payLoad?.data,
        totalRecords: payLoad?.totalRecords,
      };
    });
    //medical history
    builder.addCase(getMedicalHistoryByPetId.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.medicalHistorys = {
        totalRecords: payLoad?.totalRecords,
        medicalHistorys: payLoad?.data,
      };
    });
    builder.addCase(getMedicalHistoryById.fulfilled, (state, action) => {
      state.medicalHistory = action.payload;
    });
    //prescription
    builder.addCase(createPetPrescription.fulfilled, () => {});
    builder.addCase(getPetsCompliantSummary.fulfilled, (state, action) => {
      state.complaintSummary = action.payload;
    });
    builder.addCase(
      getPetsCompliantSummaryWoLoader.fulfilled,
      (state, action) => {
        state.complaintSummary = action.payload;
      },
    );
    builder.addCase(
      getCompliantSummaryByIdWoLoader.fulfilled,
      (state, action) => {
        state.lastSummary = action.payload;
      },
    );
    builder.addCase(getSlotTime.fulfilled, (state, action) => {
      state.slotList = action.payload;
    });
    builder.addCase(getPetPrescriptions.fulfilled, (state, action) => {
      state.prescriptions = action.payload;
    });
    builder.addCase(getPetPrescriptionsWoLoader.fulfilled, (state, action) => {
      state.prescriptions = action.payload;
    });
    builder.addCase(getPetDiagnostics.fulfilled, (state, action) => {
      state.diagnostics = action.payload;
    });
    builder.addCase(getPetDiagnosticsWoLoader.fulfilled, (state, action) => {
      state.diagnostics = action.payload;
    });
    builder.addCase(getPetPreventives.fulfilled, (state, action) => {
      state.preventives = action.payload;
    });
    builder.addCase(getFilterdPetPreventives.fulfilled, (state, action) => {
      state.filteredPreventives = action.payload;
    });
    builder.addCase(getPetTypes.fulfilled, (state, action) => {
      state.types = action.payload;
    });
    builder.addCase(getPetDetailsById.fulfilled, (state, action) => {
      state.petDetails = action.payload;
    });
    builder.addCase(getPetDetailsByIdWoLoader.fulfilled, (state, action) => {
      state.petDetails = action.payload;
    });
    builder.addCase(getProceduresByPetId.fulfilled, (state, action) => {
      state.procedure = action.payload;
    });
    builder.addCase(
      getPetDetailForSoapByIdWoLoader.fulfilled,
      (state, action) => {
        state.petDetailsForSoap = action.payload;
      },
    );
  },
});

export const {} = petSlice.actions;

export default petSlice.reducer;
